import { useDataLayerAction } from '../TagContext'
import { useCart } from '@corratech/pylot-cart-manager'

export const usePlaceOrderTracking = (): ((placedOrderId?: string) => void) => {
    const dataLayerAction = useDataLayerAction()
    const { data } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart

    return (placedOrderId?: string) => {
        if (placedOrderId) {
            dataLayerAction({
                type: 'PLACE_ORDER',
                data: {
                    actionField: {
                        order_id: placedOrderId,
                        affiliation: 'Online Store',
                        ...cart
                    },
                    cart
                }
            })
        }
    }
}
